import { Button, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const STATUS_OPTIONS = ['OPEN', 'CLOSED'] as const;

type TaskStatusColumnFilterPropsType = {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  onClose: () => void;
};

export const TaskStatusColumnFilter: React.FC<
  TaskStatusColumnFilterPropsType
> = ({ value, onChange, onClose }) => {
  const { t } = useTranslation('tasks');

  return (
    <Stack gap={4}>
      {STATUS_OPTIONS.map((status) => (
        <Button
          key={status}
          fullWidth
          justify="flex-start"
          variant={value === status ? 'light' : 'subtle'}
          onClick={() => {
            onChange(value === status ? undefined : status);
            onClose();
          }}
        >
          {t(`STATUS.${status}`)}
        </Button>
      ))}
    </Stack>
  );
};
